import { MockStoreEnhanced } from 'redux-mock-store';
import type { NotificationTheme } from '@nextgen-web-framework/all';
import { IProductEntries } from '../../checkout-order-summary/types/propTypes';

export enum DataFlowEnum {
  CHECKOUT = 'checkout',
  SUBSCRIPTION = 'subscription',
  EXTERNAL = 'EXTERNAL',
}

export enum ContainerStateEnum {
  EXPANDED = 'expanded',
  FILLED = 'filled',
  COLLAPSED = 'collapsed',
}

export interface valueMappingKey {
  [key: string]: string;
}

export interface valueMappingObject {
  [key: string]: valueMappingKey;
}

export interface CountryMasterDataInterface {
  countryName: string;
  pk: string;
  callingCode: string;
}

export interface MasterDataEntries {
  [key: string]: Array<Object>;
}

export type TranslationFunction = (str: string, values?: Record<string, string>) => string;

export interface IGenericInterface {
  onConfirmClick?: (address: unknown) => void;
  onClick?: (address: unknown) => void;
  onSuccess?: (address: unknown) => void;
  onChange?: () => void;
  onDrawerClose?: () => void;
}

export interface IMockStore {
  store: MockStoreEnhanced<unknown, {}>;
  orderId?: string;
  placeOrderViaPaymentFlag?: boolean;
}

export interface ICheckoutToast {
  toastId: string;
  message: string;
  testId?: string;
  theme?: NotificationTheme;
  onCloseCallback?: () => void;
  allowToClose?: boolean;
}
export interface ICheckoutOrderEntries {
  productEntries: Array<IProductEntries>;
  totalItems: number;
  hasEkitProduct?: boolean;
}

export interface ISkeletonConfig {
  height?: string;
  paddingTop: string;
  paddingBottom: string;
  paddingLeft?: string;
  paddingRight?: string;
  border?: string;
  borderRadius?: string;
  id?: string;
  skeletonFrames?: [];
}

export interface ICheckoutAnyType {
  [key: string]: any;
}
